import {
  Box,
  Divider,
  makeStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { PaddedContent, colors } from 'design-system';
import { useMemo } from 'react';

// Data Layer
import {
  defaultUnitDriver,
  validLegalEntity,
} from 'data-layer-cr/dist/functions/quotations';

// Models
import PricingProfileResponse from 'src/models/responseTypes/PricingProfileResponse';

// Components
import CustomerResumeCard from './CustomerResumeCard';
import IndividualUnitOption from './IndividualUnitOption';
import VehicleResumeCard from './VehicleResumeCard';

// Shared props
import DetailsContentProps from '../DetailsContentProps';

const useStyles = makeStyles(() => ({
  divider: {
    backgroundColor: colors.gallery,
    marginLeft: '-16px',
    width: '100vw',
    height: 1,
  },
  separator: {
    marginTop: '1.5rem',
    marginBottom: '1.5rem',
    height: 1,
    backgroundColor: colors.gallery,
  },
}));

interface IndividualDetailsProps extends DetailsContentProps {
  currentProfile: PricingProfileResponse;
}

const IndividualDetails = ({
  quotation,
  coverageCatalogs,
  coverageCatalogResumes,
  currentProfile,
}: IndividualDetailsProps): JSX.Element => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const driver = useMemo(() => defaultUnitDriver(quotation), [quotation]);

  return (
    <PaddedContent data-testid="padded-content">
      <Box
        style={
          isMobile
            ? { marginBlock: '0px' }
            : { marginTop: '1rem', marginBottom: '0.5rem' }
        }
      >
        <Box
          display="grid"
          gridTemplateColumns={isMobile ? '1fr' : '1fr 1fr 1fr'}
          justifyItems="center"
          width="100%"
          style={{ gap: '1rem' }}
        >
          {quotation.units.map((_unit, index) => (
            <IndividualUnitOption
              key={`OptionPrice-${index + 1}`}
              packageOption={index}
              currentProfile={currentProfile}
              quotation={quotation}
              coverages={coverageCatalogs}
              coverageResumes={coverageCatalogResumes}
            />
          ))}
        </Box>
        <Box>
          <Divider
            data-testid="section-divider"
            className={classes.separator}
          />
          <Box
            display="grid"
            gridTemplateColumns={isMobile ? '1fr' : '1fr 1fr 1fr'}
            justifyItems="center"
            width="100%"
            style={{ gap: '1rem' }}
          >
            <CustomerResumeCard
              data-testid="customer-section"
              customerType={quotation.customerType}
              customer={quotation.customer}
              legalEntity={validLegalEntity(quotation)}
              driver={driver}
            />
            <VehicleResumeCard
              data-testid="car-section"
              quotationSummary={quotation.summary}
            />
          </Box>
        </Box>
      </Box>
    </PaddedContent>
  );
};

export default IndividualDetails;
